import React, { Component } from 'react';

export default class Loader extends Component {
	constructor(props) {
		super(props);
		this.state = {
			status: [
				'Fetching Results For You',
				'You Are Doing A Very Nice Job.',
				'Almost There....'
			],
			current: 0
		}
	}

	currentString() {
		return (
			<div>{this.state.status[this.state.current]}</div>
		)
	}

	componentDidMount() {
  		this.interval = setInterval(() => this.changeStatus(), 2000);
	}

	componentWillUnmount() {
	  clearInterval(this.interval);
	}

	changeStatus() {
		var crt = this.state.current;
		var newCrt = (crt + 1) % (this.state.status.length);
		this.setState({current: newCrt});
	}

	render() {
		return(
			<div className="no-jobs-to-assign">
				<div className="lds-hourglass"></div>
				<div>{this.currentString()}</div>
			</div>
		)
	}
} 


// WEBPACK FOOTER //
// ./src/commons/Loader.js